<agr-page-toolbar
  [pageTitle]="pageTitle$ | async"
  [hasPrimaryAction]="allowedToCUD$ | async"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="openProductCreate()"
  data-test="product-overview"
>
  <ng-container actions *ngIf="(isCustomerProducts$ | async) === false">
    <mat-select
      [hideSingleSelectionIndicator]="true"
      class="flex__child--auto spacing--margin-right text--small regionSelector"
      data-placeholder="{{ 'region' | translate }}"
      data-test="product-country-selector"
      (selectionChange)="changeRegionSelection($event)"
      [value]="selectedRegion$ | async"
    >
      <mat-option *ngFor="let region of regions" [value]="region.id">
        {{ 'regions.' + region.id | translate }}
      </mat-option>
    </mat-select>
  </ng-container>

  <ng-container *ngIf="tableConfig$ | async as tableConfig">
    <agr-table
      *ngIf="tableConfig"
      [emptyTitle]="'product-overview.no-products.title' | translate"
      [emptyDescription]="'product-overview.no-products.description' | translate"
      emptyImage="assets/images/pigs_001.jpg"
      [config]="tableConfig"
      class="table"
    ></agr-table>
  </ng-container>
</agr-page-toolbar>

<ng-template #nameTemplate let-row="row">
  <a (click)="openProductView(row.id)" class="button" data-test="table-desktop__col-actions-view">{{
    row.name ?? 'No name'
  }}</a>
</ng-template>
